import React from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { getAnchors, getZones, getStates, setInitialState, setRowInReducer } from '../../actions/AdministrationActions';
import i18n from '../../i18n/i18n';
import Select from 'react-select';
import immutable from 'seamless-immutable';
import ViewAnchorAgent from './ViewAnchorAgent';
import ViewAnchorDocument from './ViewAnchorDocument';
import { Fab } from '@material-ui/core';
import AddAnchor from './AddAnchor';
import checkboxHOC from "react-table/lib/hoc/selectTable";
import { getLocalGov } from '../../actions/FarmRegistarActions';
const CheckboxTable = checkboxHOC(ReactTable);
export class ViewAnchors extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showFilters: false,
            add: false,
            selection: [],
            selectAll: false,
            view: false,
            documents: false
        };
    }

    componentDidMount() {
        this.props.getZones();
        this.props.getStates();
        this.props.getLocalGov();
    }


    componentWillReceiveProps(nextProps) {
        if (nextProps.anchorPostingSuccess === true) {
            this.handleClick();
            const wrapped = this.checkboxTable.getWrappedInstance();
            this.props.getAnchors(wrapped.state);
            this.props.setInitialState('anchorPostingSuccess');
        }
        this.setState({
            anchors: nextProps.anchors,
            anchorsFetching: nextProps.anchorsFetching,
            zones: immutable.asMutable(nextProps.zones.map((item) => { return { label: item.naziv, value: item.id } }), { deep: true }),
            localGovernments: immutable.asMutable(nextProps.localGoverments.map((item) => { return { label: item.naziv, value: item.id } }), { deep: true }),
            zonesFetching: nextProps.zonesFetching,
            zonesFetchingFailed: nextProps.zonesFetchingFailed,
            states: immutable.asMutable(nextProps.states.map((item) => { return { label: item.naziv, value: item.id } }), { deep: true }),
            statesFetching: nextProps.statesFetching,
            statesFetchingFailed: nextProps.statesFetchingFailed,
        })
    }

    onSearchClick() {
        this.setState({ showFilters: !this.state.showFilters });
    }

    handleClick = () => {
        this.setState({ add: !this.state.add });
    };

    handleClickAnchorAgent = () => {
        this.setState({ info: !this.state.info });
    };

    handleClickAnchorDocument = () => {
        this.setState({ documents: !this.state.documents });
    };

    toggleSelection = (key, shift, row) => {
        let selection = [...this.state.selection];
        const keyIndex = selection.indexOf(key);
        if (keyIndex >= 0) {
            selection = [
                ...selection.slice(0, keyIndex),
                ...selection.slice(keyIndex + 1)
            ];
        } else {
            selection.push(key);
        }
        this.setState({ selection, selectionLocGov: row.id_katastarska_opstina })
    };

    toggleAll = () => {
        const selectAll = this.state.selectAll ? false : true;
        const selection = [];
        if (selectAll) {
            const wrappedInstance = this.checkboxTable.getWrappedInstance();
            const currentRecords = wrappedInstance.getResolvedState().sortedData;
            currentRecords.forEach(item => {
                selection.push(item._original.id);
            });
        }
        this.setState({ selectAll, selection });
    };

    isSelected = key => {
        return this.state.selection.includes(key);
    };

    render() {
        const { toggleSelection, toggleAll, isSelected } = this;
        const { selectAll, selection, selectionLocGov } = this.state;
        const checkboxProps = {
            selectAll,
            isSelected,
            toggleSelection,
            toggleAll,
            selectType: "checkbox",
            getTrProps: (state, rowInfo, instance) => {
                if (rowInfo) {
                    const selected = this.isSelected(rowInfo.original.id);
                    return {
                        style: {
                            backgroundColor: selected ? "lightgreen" : "inherit"
                        }
                    };
                }
                return {};
            }
        };
        return (
            <div className="page">
                <div className="table-header">
                    <Fab
                        onClick={() => this.handleClick()}
                        color="primary"
                        aria-label="add"
                        className="action-button"
                    >
                        <span className="icon-Plus headerIcon" />
                    </Fab>
                    <Fab
                        onClick={() => this.onSearchClick()}
                        color="primary"
                        aria-label="add"
                        className="action-button"
                    >
                        <span className="icon-search headerIcon" />
                    </Fab>
                    {selection.length === 1 &&
                        <Fab
                            onClick={() => this.handleClickAnchorAgent()}
                            color="primary"
                            aria-label="info"
                            className="action-button"
                        >
                            <span className="icon-Informacija headerIcon" />
                        </Fab>
                    }
                    {selection.length === 1 &&

                        <Fab
                            onClick={() => this.handleClickAnchorDocument()}
                            color="primary"
                            aria-label="info"
                            className="action-button"
                        >
                            <span className="icon-file-text headerIcon" />
                        </Fab>
                    }
                </div>
                <CheckboxTable data={this.props.anchors}
                    ref={r => (this.checkboxTable = r)}
                    columns={this.columns}
                    keyField={'id'}
                    pageSizeOptions={[10, 25, 50, 100]}
                    defaultPageSize={25}
                    filterable={this.state.showFilters}
                    pages={this.props.anchorsPages}
                    loading={this.props.anchorsFetching}
                    manual
                    showPaginationTop
                    showPaginationBottom={false}
                    onFetchData={(state, instance) => this.props.getAnchors(state, instance)}
                    previousText={i18n.t('Previous')}
                    nextText={i18n.t('Next')}
                    loadingText={i18n.t('Loading...')}
                    noDataText={i18n.t('No rows found')}
                    pageText={i18n.t('Page')}
                    ofText={i18n.t('of')}
                    rowsText={i18n.t('rows')}
                    {...checkboxProps}
                />
                {this.state.add && <AddAnchor add={this.state.add}
                    handleClose={this.handleClick} />}
                {this.state.info && <ViewAnchorAgent info={this.state.info}
                    handleClose={this.handleClickAnchorAgent}
                    id_klijent_soc={selection[0]}
                    selectionLocGov={selectionLocGov} />}
                {this.state.documents && <ViewAnchorDocument documents={this.state.documents}
                    id_klijent={selection[0]}
                    handleClose={this.handleClickAnchorDocument}
                />}
            </div>
        )
    }

    columns = [
        {
            Header: i18n.t('Anchor'),
            accessor: 'naziv',
            resizable: false,
        },
        {
            Header: i18n.t('Zone'),
            accessor: 'zona_naziv',
            resizable: false,
            Filter: ({ filter, onChange }) =>
                <Select
                    isMulti
                    name="naziv"
                    onChange={value => {
                        onChange(value)
                    }}
                    closeMenuOnSelect={false}
                    options={this.state.zones}
                    className="multi-select-in-filter"
                    classNamePrefix="select"
                    placeholder={i18n.t('Select')}
                />
        },
        {
            Header: i18n.t('State'),
            accessor: 'opstina_naziv',
            resizable: false,
            Filter: ({ filter, onChange }) =>
                <Select
                    isMulti
                    name="naziv"
                    onChange={value => {
                        onChange(value)
                    }}
                    closeMenuOnSelect={false}
                    options={this.state.states}
                    className="multi-select-in-filter"
                    classNamePrefix="select"
                    placeholder={i18n.t('Select')}
                />
        },
        {
            Header: i18n.t('Local government'),
            accessor: 'katastarska_opstina_naziv',
            resizable: false,
            Filter: ({ filter, onChange }) =>
                <Select
                    isMulti
                    name="naziv"
                    onChange={value => {
                        onChange(value)
                    }}
                    closeMenuOnSelect={false}
                    options={this.state.localGovernments}
                    className="multi-select-in-filter"
                    classNamePrefix="select"
                    placeholder={i18n.t('Select')}
                />
        },
        {
            Header: i18n.t('Address'),
            accessor: 'ulica_i_broj',
            resizable: false
        },
        {
            Header: i18n.t('Email'),
            accessor: 'kontakt_mejl',
            resizable: false
        },
        {
            Header: i18n.t('Phone'),
            accessor: 'kontakt_mobilni',
            resizable: false
        },
        {
            Header: i18n.t('Boa Number'),
            accessor: 'boa_number',
            resizable: false
        },
        {
            Header: i18n.t('RC Number'),
            accessor: 'rc_number',
            resizable: false
        },
        {
            Header: i18n.t('BVN'),
            accessor: 'bpg',
            resizable: false
        },
        {
            Header: i18n.t('Type of Business'),
            accessor: 'delatnost',
            resizable: false
        },
        {
            Header: i18n.t('Number of Years in Business'),
            accessor: 'num_years_business',
            resizable: false
        },
        {
            Header: i18n.t('Date of Incorporation / Registration'),
            accessor: 'incorporation_date',
            resizable: false
        },
        {
            Header: i18n.t('Zip code'),
            accessor: 'postanski_broj',
            resizable: false
        },
    ];
};

function mapStateToProps(state) {
    return {
        anchors: state.administrationReducer.anchors,
        anchorsFetching: state.administrationReducer.anchorsFetching,
        anchorsPages: state.administrationReducer.anchorsPages,
        zones: state.administrationReducer.zones,
        zonesFetching: state.administrationReducer.zonesFetching,
        zonesFetchingFailed: state.administrationReducer.zonesFetchingFailed,
        states: state.administrationReducer.states,
        localGoverments: state.farmRegistarReducer.localGoverments,
        anchorPostingSuccess: state.administrationReducer.anchorPostingSuccess,
        statesFetching: state.administrationReducer.statesFetching,
        statesFetchingFailed: state.administrationReducer.statesFetchingFailed
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getZones: () => dispatch(getZones()),
        getStates: () => dispatch(getStates()),
        getLocalGov: (id_state) => dispatch(getLocalGov(id_state)),
        setInitialState: (component) => dispatch(setInitialState(component)),
        setRowInReducer: (rowInfo, name) => dispatch(setRowInReducer(rowInfo, name)),
        getAnchors: (state, instance) => dispatch(getAnchors(state, instance)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewAnchors)